import { AxiosResponse } from 'axios';
import { MutationOptions, useMutation, useQueryClient } from '@tanstack/react-query';
import { updateRule } from 'Services';
import {
    RQ_ALL_LIST,
    RQ_GLOBAL_RULES,
    RQ_HISTORY,
    RQ_LIST_BY_ID,
    RQ_MERCHANT_OVERRIDES,
    RQ_MERCHANT_RULES,
    RQ_PARAMETERS,
    RQ_RULE_GROUPS
} from 'Utils';

type Options = {
    mutationOptions: Omit<MutationOptions<AxiosResponse<AddNewRuleSchema>, any, any, any>, 'mutationKey'>;
    templateRepositoryId: number;
};

function useUpdateRule(ruleId: number, { templateRepositoryId, mutationOptions }: Options) {
    const queryClient = useQueryClient();
    const defaultSuccessHandler = () => {
        queryClient.invalidateQueries([RQ_GLOBAL_RULES, templateRepositoryId]);
        queryClient.invalidateQueries([RQ_MERCHANT_RULES]);
        queryClient.invalidateQueries([RQ_MERCHANT_OVERRIDES]);
        queryClient.invalidateQueries([RQ_RULE_GROUPS]);
        queryClient.invalidateQueries([RQ_HISTORY]);
        queryClient.invalidateQueries([RQ_ALL_LIST]);
        queryClient.invalidateQueries([RQ_LIST_BY_ID]);
        queryClient.invalidateQueries([RQ_PARAMETERS]);
    };

    return useMutation((newValues: AddNewRuleSchema) => updateRule(ruleId, newValues), {
        onSuccess: (data, variables, context) => {
            defaultSuccessHandler();
            mutationOptions.onSuccess?.(data, variables, context);
        },
        onError: async (error, variables, context) => mutationOptions.onError?.(error, variables, context)
    });
}

export default useUpdateRule;
